<template>
  <div :class="calcClasses">
    <Button @click.native="show" />
    <Machine class="machine" />
    <svg :class="pointerClasses" width="23" height="29" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 24.015L22.75 0 4.807 28.756S0 25.279 0 24.016" fill="#E61E14"/></g></svg>
    <Ticket :print="showTicket" />
  </div>
</template>

<script>
import Machine from './Machine'
import Button from './Button'
import Ticket from './Ticket'

export default {
  name: 'CO2Calc',
  data () {
    return {
      showTicket: false
    }
  },
  components: {
    Machine,
    Button,
    Ticket
  },
  computed: {
    calcClasses () {
      return {
        'co2-calc': true,
        'calculate': this.showTicket
      }
    },
    pointerClasses () {
      return {
        'pointer': true,
        'rotate': this.showTicket
      }
    }
  },
  methods: {
    show () {
      this.showTicket = true
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.co2-calc {
  margin: 3em auto;
  height: 519px;
  position: relative;
  max-height: 260px;
  transition: 400ms max-height ease 1200ms;
}

.calculate {
  animation: shake 0.9s cubic-bezier(0.36, 0.07, 0.19, 0.97) both 300ms;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  max-height: 519px;
}

.machine {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  transition: transform 1s cubic-bezier(.19,1,.22,1) 0.2s;
  will-change: transform;
}

.pointer {
  position: absolute;
  z-index: 4;
  top: 114px;
  left: 50%;
  transform: translateX(-50%) rotate(0deg);
  transform-origin: 0 100%;
  margin-left: 12px;
  transition: transform 1s cubic-bezier(.19,1,.22,1) 1s;
  will-change: transform;
}

.rotate {
  transform: translateX(-50%) rotate(180deg);
}
</style>
